import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class PermissionVm {
	id: number;
	coreFeatures: boolean;
	manageSiteUsers: boolean;
	siteBusinessDays: boolean;
	manageSites: boolean;
	transferWithinOrg: boolean;
	replenishment: boolean;
	transferOutsideOfOrg: boolean;
	manageOrganizations: boolean;
	manageOrgUsers: boolean;
	deactivateSites: boolean;
	viewAllSitesForOrg: boolean;
	viewAllSites: boolean;
	deactivateOrgs: boolean;
	reports: boolean;
	adminFeatures: boolean;
	permissionProfileString?: string;
	viewQuartzJobs: boolean;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'id': new UntypedFormControl(0, [...(validators['id'] ?? []), ...[Validators.required]]),
			'coreFeatures': new UntypedFormControl(false, [...(validators['coreFeatures'] ?? []), ...[]]),
			'manageSiteUsers': new UntypedFormControl(false, [...(validators['manageSiteUsers'] ?? []), ...[]]),
			'siteBusinessDays': new UntypedFormControl(false, [...(validators['siteBusinessDays'] ?? []), ...[]]),
			'manageSites': new UntypedFormControl(false, [...(validators['manageSites'] ?? []), ...[]]),
			'transferWithinOrg': new UntypedFormControl(false, [...(validators['transferWithinOrg'] ?? []), ...[]]),
			'replenishment': new UntypedFormControl(false, [...(validators['replenishment'] ?? []), ...[]]),
			'transferOutsideOfOrg': new UntypedFormControl(false, [...(validators['transferOutsideOfOrg'] ?? []), ...[]]),
			'manageOrganizations': new UntypedFormControl(false, [...(validators['manageOrganizations'] ?? []), ...[]]),
			'manageOrgUsers': new UntypedFormControl(false, [...(validators['manageOrgUsers'] ?? []), ...[]]),
			'deactivateSites': new UntypedFormControl(false, [...(validators['deactivateSites'] ?? []), ...[]]),
			'viewAllSitesForOrg': new UntypedFormControl(false, [...(validators['viewAllSitesForOrg'] ?? []), ...[]]),
			'viewAllSites': new UntypedFormControl(false, [...(validators['viewAllSites'] ?? []), ...[]]),
			'deactivateOrgs': new UntypedFormControl(false, [...(validators['deactivateOrgs'] ?? []), ...[]]),
			'reports': new UntypedFormControl(false, [...(validators['reports'] ?? []), ...[]]),
			'adminFeatures': new UntypedFormControl(false, [...(validators['adminFeatures'] ?? []), ...[]]),
			'permissionProfileString': new UntypedFormControl(null, [...(validators['permissionProfileString'] ?? []), ...[]]),
			'viewQuartzJobs': new UntypedFormControl(false, [...(validators['viewQuartzJobs'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): PermissionVmFromFg {
		return new PermissionVmFromFg(fg);
	}
}

export class PermissionVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get id(): number {
		return this.fg.get('id').value;
	}
	set id(val) {
		this.fg.get('id').setValue(val);
	}

	get coreFeatures(): boolean {
		return this.fg.get('coreFeatures').value;
	}
	set coreFeatures(val) {
		this.fg.get('coreFeatures').setValue(val);
	}

	get manageSiteUsers(): boolean {
		return this.fg.get('manageSiteUsers').value;
	}
	set manageSiteUsers(val) {
		this.fg.get('manageSiteUsers').setValue(val);
	}

	get siteBusinessDays(): boolean {
		return this.fg.get('siteBusinessDays').value;
	}
	set siteBusinessDays(val) {
		this.fg.get('siteBusinessDays').setValue(val);
	}

	get manageSites(): boolean {
		return this.fg.get('manageSites').value;
	}
	set manageSites(val) {
		this.fg.get('manageSites').setValue(val);
	}

	get transferWithinOrg(): boolean {
		return this.fg.get('transferWithinOrg').value;
	}
	set transferWithinOrg(val) {
		this.fg.get('transferWithinOrg').setValue(val);
	}

	get replenishment(): boolean {
		return this.fg.get('replenishment').value;
	}
	set replenishment(val) {
		this.fg.get('replenishment').setValue(val);
	}

	get transferOutsideOfOrg(): boolean {
		return this.fg.get('transferOutsideOfOrg').value;
	}
	set transferOutsideOfOrg(val) {
		this.fg.get('transferOutsideOfOrg').setValue(val);
	}

	get manageOrganizations(): boolean {
		return this.fg.get('manageOrganizations').value;
	}
	set manageOrganizations(val) {
		this.fg.get('manageOrganizations').setValue(val);
	}

	get manageOrgUsers(): boolean {
		return this.fg.get('manageOrgUsers').value;
	}
	set manageOrgUsers(val) {
		this.fg.get('manageOrgUsers').setValue(val);
	}

	get deactivateSites(): boolean {
		return this.fg.get('deactivateSites').value;
	}
	set deactivateSites(val) {
		this.fg.get('deactivateSites').setValue(val);
	}

	get viewAllSitesForOrg(): boolean {
		return this.fg.get('viewAllSitesForOrg').value;
	}
	set viewAllSitesForOrg(val) {
		this.fg.get('viewAllSitesForOrg').setValue(val);
	}

	get viewAllSites(): boolean {
		return this.fg.get('viewAllSites').value;
	}
	set viewAllSites(val) {
		this.fg.get('viewAllSites').setValue(val);
	}

	get deactivateOrgs(): boolean {
		return this.fg.get('deactivateOrgs').value;
	}
	set deactivateOrgs(val) {
		this.fg.get('deactivateOrgs').setValue(val);
	}

	get reports(): boolean {
		return this.fg.get('reports').value;
	}
	set reports(val) {
		this.fg.get('reports').setValue(val);
	}

	get adminFeatures(): boolean {
		return this.fg.get('adminFeatures').value;
	}
	set adminFeatures(val) {
		this.fg.get('adminFeatures').setValue(val);
	}

	get permissionProfileString(): string {
		return this.fg.get('permissionProfileString').value;
	}
	set permissionProfileString(val) {
		this.fg.get('permissionProfileString').setValue(val);
	}

	get viewQuartzJobs(): boolean {
		return this.fg.get('viewQuartzJobs').value;
	}
	set viewQuartzJobs(val) {
		this.fg.get('viewQuartzJobs').setValue(val);
	}
}
